// 二代身份证
export const validIDCard = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
// email(支持中文邮箱)
export const validEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
// 正整数
export const validInteger = /^[1-9]\d*$/
// 保留两位小数
export const validNumber2 = /^\d+(?:\.\d{1,2})?$/
// 保留三位小数
export const validNumber3 = /^\d+(?:\.\d{1,3})?$/
// 重置密码校验
export const validPsw = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/
// 手机号校验
export const validPhoneNumber = /^1[3-9]\d{9}$/
// 域名校验
export const validDomain = /^([0-9a-zA-Z-]{1,}\.)+([a-zA-Z]{2,})$/
// 企业统一信用代码校验
export const validUSCI = /^[A-Z0-9]{18}$/
// 车牌号校验
export const validLicensePlate = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼](?:[A-HJ-NP-Z](?:[0-9]{5}|[A-HJ-NP-Z0-9]{4}[0-9DF])|(?:[0-9A-HJ-NP-Z]{6})|[A-HJ-NP-Z][DF][0-9A-HJ-NP-Z]{6})|^粤Z[A-HJ-NP-Z0-9]{4}[港澳]$/

export const validateLicensePlate = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入车牌号'))
  }

  // 普通车牌
  const commonPlateRegex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/

  // 新能源车牌
  const newEnergyPlateRegex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z](?:[0-9]{5}[DF]|[DF][A-HJ-NP-Z0-9][0-9]{4})$/

  if (commonPlateRegex.test(value) || newEnergyPlateRegex.test(value)) {
    callback()
  } else {
    callback(new Error('请输入有效的车牌号码'))
  }
}
